<template>
  <div>
    <div class="contents">
      <header>
        <div style="display: inherit; margin: auto">
          <div>
            <div style="width: 100%; clear: both">
              <h2>{{ $t("VelkommenTilIda") }}</h2>
            </div>
            <div class="blockswrapper">
              <q-card class="f-card" v-if="forgotPassword">
                <q-card-section>
                  <h3>{{ $t("forgotPassword.forgottenPasswordHeader") }}</h3>
                  <div data-validate="Username is required">
                    <ISTFormInput v-model="Username" :label="$t('username')" />
                  </div>
                  <br />
                  <q-btn
                    color="primary"
                    class="full-width"
                    label="Send gendannelseslink"
                    @click="sendPasswordRecoveryLink"
                  />
                  <div>
                    <a @click="goToLogin" class="link">{{ $t("forgotPassword.goToLogin") }}</a>
                  </div>
                </q-card-section>
              </q-card>
              <div class="bottom-block" v-if="forgotPassword">
                {{ $t("forgotPassword.recoveryLinkInformation") }}
              </div>
              <q-card class="f-card" v-if="!forgotPassword">
                <q-card-section>
                  <h3>Login leder</h3>
                  <q-form
                    @submit="doIdpLogin('faelleskommunaladgangsstyring2')"
                    v-show="showFkaLogin"
                  >
                    <q-btn
                      color="primary"
                      class="full-width"
                      id="unilogin-btn"
                      label="Kommunelogin"
                      type="submit"
                    />
                  </q-form>
                  <br v-if="showFkaLogin" />
                  <hr v-if="showFkaLogin" />
                  <br v-if="showFkaLogin" />

                  <q-form @submit="dologin">
                    <div data-validate="Username is required">
                      <ISTFormInput v-model="Username" :label="$t('username')" :autofocus="true" />
                    </div>
                    <div data-validate="Username is required" style="margin-top: 12px">
                      <ISTFormInput
                        v-model="Password"
                        :label="$t('Password')"
                        type="password"
                        ref="passwordfield"
                      />
                    </div>
                    <div class="flex-sb-m w-full p-b-48">
                      <q-checkbox left-label v-model="rememberme" :label="$t('RememberMe')" />
                    </div>

                    <q-btn
                      color="primary"
                      class="full-width"
                      :label="$t('btnLogin')"
                      type="submit"
                    />
                    <div>
                      <a @click="forgottenPassword" class="link">{{ $t("ForgotPassword") }}</a>
                    </div>
                  </q-form>
                </q-card-section>
                <q-card-section>
                  <h3>Login leder/medarbejder</h3>

                  <q-form @submit="doIdpLogin('unilogin')">
                    <q-btn
                      color="primary"
                      class="full-width"
                      id="unilogin-btn"
                      label="Unilogin"
                      type="submit"
                    />
                  </q-form>
                </q-card-section>
              </q-card>
              <div class="bottom-block" v-if="!forgotPassword">
                {{ $t("Frontpageinfo") }}
                <a href="https://www.ist.com/da" target="_blank" class="link">www.ist.com</a>
                {{ $t("Frontpageinfo2") }}
                <q-banner
                  v-if="uniloginerror !== ''"
                  inline-actions
                  rounded
                  class="bg-orange text-white errorbanner"
                >
                  <div v-html="uniloginerror"></div>
                </q-banner>
              </div>
              <div class="bottom-block" v-if="servererror !== ''">
                <q-banner inline-actions rounded class="bg-orange text-white errorbanner">
                  <div v-html="servererror"></div>
                </q-banner>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  </div>
</template>
<script lang="ts">
import { Dialog } from "quasar";
import { Vue, Ref } from "vue-property-decorator";
import IstFormInput from "@/components/IstFormInput.vue";
import i18n from "../i18n";
import store from "@/store";
import { useRouter } from "vue-router";
import { eEventBus, EventBus } from "@/eventbus";

export default class IDA extends Vue {
  router = useRouter();
  Password = "";
  Username = "";
  rememberme = false;
  servererror = "";
  uniloginerror = "";
  forgotPassword = false;
  successMessage = "";
  showFkaLogin = true;

  @Ref("passwordfield") readonly passwordfield2!: HTMLInputElement;
  @Ref() readonly passwordfield!: typeof IstFormInput;

  forgottenPassword() {
    this.forgotPassword = !this.forgotPassword;
  }

  goToLogin() {
    this.forgotPassword = !this.forgotPassword;
  }

  created() {
    this.Username = localStorage.getItem("username") ?? "";
    if (this.Username !== "") {
      this.rememberme = true;
    }
  }
  mounted() {
    if (this.Username !== "") {
      (this.passwordfield as any).$el.focus();
    }
    const error = sessionStorage.getItem("loginError");
    if (error && error !== "") {
      this.servererror = error;
      sessionStorage.removeItem("loginError");
      if (error.indexOf("har ikke adgang til Dagtilbud Personale") > -1) {
        this.uniloginerror = "<b>Medarbejder:</b><br>Din leder skal give dig webadgang.<br><br>";
        this.uniloginerror +=
          "<b>Leder:</b><br>" +
          "<b>Hvis du allerede har et brugernavn og adgangskode</b>" +
          "<br>Har du allerede en almindelig bruger, kan du logge ind med denne og derefter under dit brugernavn vælge menupunktet 'Skift til Unilogin'." +
          "<br>Her kan du  gennemgå processen for at få tilknyttet din Unilogin bruger til din institution." +
          "<br><br>Har du allerede gjort overstående og har modtaget en aktiveringsmail, skal du klikke på linket i mailen.";

        this.uniloginerror +=
          "<br><br><b>Hvis du ikke har haft adgang til Dagtilbud Personale før</b>" +
          "<br>Hvis du har modtaget en aktiveringsmail bedes du klikke på linket i mailen." +
          "<br><br>Har du ikke modtaget en aktiveringsmail, bedes du kontakte IST Support.";
      }
    }
    EventBus.on(eEventBus.loginError, async (error) => {
      this.servererror = error;
      sessionStorage.setItem("loginError", error);
      store.commit("security/logout");
    });
  }
  sendPasswordRecoveryLink() {
    store
      .dispatch("security/sendRecoveryLink", {
        username: this.Username
      })
      .then(() => {
        Dialog.create({
          title: i18n.global.t("forgotPassword.forgottenPasswordHeader").toString(),
          message: i18n.global.t("forgotPassword.resetMailSent").toString(),
          color: "primary",
          html: true,
          ok: true // takes i18n value, or String for "OK" button label
        }).onOk(async () => {
          this.forgotPassword = false;
        });
      })
      .catch((error) => {
        this.servererror = "";
        this.uniloginerror = "";
        if (error?.errors) {
          error?.errors.forEach((error) => {
            this.servererror += error.message + "\n";
          });
        }
      });
  }
  dologin(): void {
    this.servererror = "";
    this.uniloginerror = "";
    store
      .dispatch("security/loginBasic", {
        username: this.Username,
        password: this.Password
      })
      .then(() => {
        if (this.rememberme) {
          localStorage.setItem("username", this.Username);
        } else {
          localStorage.removeItem("username");
        }

        this.router.push({ path: "/module/dashboard" });
      })
      .catch((error) => {
        (this.passwordfield as any).$el.focus();
        // eslint-disable-next-line no-console
        console.error("login error", error);

        if (error?.errors) {
          error?.errors.forEach((error) => {
            this.servererror += error.message + "\n";
          });
        }
      });
  }

  async doIdpLogin(idpHint: string): Promise<void> {
    sessionStorage.setItem("idpHint", idpHint);
    this.servererror = "";
    this.uniloginerror = "";
    if (localStorage.getItem("userActivation")) {
      localStorage.removeItem("userActivation");
    }
    store.dispatch("security/idpAuthenticate").catch((error) => {
      if (error?.errors) {
        error?.errors.forEach((error) => {
          this.servererror += error.message + "\n";
        });
      }
    });
  }
}
</script>

<style scoped>
.link {
  color: #fff;
  cursor: pointer;
  text-decoration: underline;
}

.f-card {
  color: #000;
  padding-right: 20px;
  width: 50%;
  min-width: 329px;
  flex-grow: 1;
  order: 1;
}
body {
  margin: 0;
  padding: 0;
  background-color: #589dc9;
  text-align: left;
}

header {
  width: 100%;
  background-color: #006a83;
  color: #fff;
  display: table;
}
header > div {
  vertical-align: top;
  height: 100%;
  overflow: auto;
  padding: 3vw;
  background-color: inherit;
}
header h2 {
  margin-top: 0;
  color: #fff;
}
.contents {
  max-width: 960px;
  width: 94%;
  margin: auto;
  margin-top: 3vw;
}
.bottom-block {
  width: calc(50% - 20px);
  min-width: 329px;
  flex-grow: 1;
  margin-bottom: 3vw;
}
.blockswrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.errorbanner {
  margin-right: 15px;
  margin-top: 15px;
}
</style>
